module.exports = __webpack_public_path__ + "media/toast-warning.bf610b4d.webm";